import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const kronos = defineConnector({
  identifier: "kronos",
  name: "Kronos",
  tagLine: "Workforce management and timekeeping",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ serverUrl }) => domainToRegex(serverUrl),
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your Kronos API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. In Kronos, go to **Administration › Application Setup › System Configuration › Authentication**
2. Generate an API key or retrieve your existing credentials
3. Copy the API key`,
        },
      ],
    },
    {
      title: "Enter your Kronos details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://kronos.example.com",
          target: { kind: "configuration", field: "serverUrl" },
          helperText: "The base URL of your Kronos instance.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) => `${serverUrl}/api/authentication/token`,
  },
});
